import React from 'react';
import './ContactSection.css';

const contactCards = [
  {
    icon: '📞',
    headline: 'Call Us (India)',
    content: '+91 7499 166215',
  },
  {
    icon: '✉️',
    headline: 'Email',
    content: 'codenovaai@gmail.com',
  },
  {
    icon: '📍',
    headline: 'Office',
    content: 'Lucknow, India',
  },
  {
    icon: '💬',
    headline: 'WhatsApp',
    content: '+91 7499 166215',
  },
];

const Contact: React.FC = () => (
  <section className="contact-cn-section">
    <div className="contact-cn-wrapper">
      <div className="contact-cn-info-block">
        <h2 className="contact-cn-title gradient-text">Contact Us</h2>
        <div className="contact-cn-cards">
          {contactCards.map((card, i) => (
            <div className="contact-cn-card" key={i}>
              <span className="contact-cn-icon">{card.icon}</span>
              <div>
                <div className="contact-cn-card-hd">{card.headline}</div>
                <div className="contact-cn-card-content">{card.content}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <form className="contact-cn-form" onSubmit={e => e.preventDefault()}>
        <div className="contact-cn-form-title">Send us a message</div>
        <div className="cn-form-row">
          <input className="contact-cn-input" placeholder="Your Name" type="text" required />
        </div>
        <div className="cn-form-row">
          <input className="contact-cn-input" placeholder="Your Email" type="email" required />
        </div>
        <div className="cn-form-row">
          <input className="contact-cn-input" placeholder="Subject" type="text" />
        </div>
        <div className="cn-form-row">
          <textarea className="contact-cn-textarea" placeholder="Your Message..." rows={5} required></textarea>
        </div>
        <button className="contact-cn-submit" type="submit">Send Message</button>
      </form>
    </div>
  </section>
);

export default Contact;
